import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import CommissionLog from './commission-log';
import CommissionLogDetail from './commission-log-detail';
import CommissionLogUpdate from './commission-log-update';
import CommissionLogDeleteDialog from './commission-log-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={CommissionLogUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={CommissionLogUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={CommissionLogDetail} />
      <ErrorBoundaryRoute path={match.url} component={CommissionLog} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={CommissionLogDeleteDialog} />
  </>
);

export default Routes;
